export const SIGN_UP = '/signup/';
export const SIGN_IN = '/signin/';
export const PASSWORD_FORGET = '/pw-forget/';

export const CLIENTPORTAL = '/';
export const OUTLINE = '/outline/';
export const BORES = '/bores/';

export const TIMESHEETS = '/timesheets/';
export const MAINTENANCE = '/maintenance/';
export const PRESTARTS = '/prestarts/';
export const PROFILE = '/profile/';
export const DEVELOPER = '/developer/';
export const EXPLOSIVEINV = '/explosive-inv';
export const CALENDAR = '/calendar';
